export default "__VITE_ASSET__pP7XGAUA__"